<ng-container *ngIf="permConfig.isAddAllowed">
<div class="container-fluid">
    <app-page-title title="Sales Invoice"></app-page-title>
    <form [formGroup]="invoiceForm">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="company" class="form-label">Company<span class="mandatory">*</span></label>
                                    <ng-select #companyRef id="company" formControlName="ddlCompany" [items]="companyList"
                                        [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" 
                                        [ngClass]="{'is-invalid':(isFormSubmitted || invoiceForm.get('ddlCompany').touched) && invoiceForm.get('ddlCompany').errors}" 
                                        (keydown.enter)="useEnterKey && invoiceForm.get('ddlCompany').valid ? paymentModeRef.focus() : invoiceForm.get('ddlCompany').markAsTouched()">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('ddlCompany')?.touched) && invoiceForm.get('ddlCompany').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('ddlCompany').errors.required">Company is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="paymentmode" class="form-label">Payment Type</label>
                                    <ng-select #paymentModeRef id="paymentmode" placeholder="Select" formControlName="ddlPaymentType"
                                        [items]="paymentOptions" bindLabel="name" [appendTo]="'body'" [openOnEnter]="false"
                                        [bindValue]="'name'" [clearable]="false" 
                                        (keydown.enter)="useEnterKey && invoiceDateRef.focus()"></ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="invoiceDate" class="form-label">Invoice Date<span
                                            class="mandatory">*</span></label>
                                    <input #invoiceDateRef id="invoiceDate" class="form-control form-control-sm" type="date"
                                        placeholder="Select" formControlName="txtInvoiceDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtInvoiceDate')?.touched) && invoiceForm.get('txtInvoiceDate').errors}" 
                                        (keydown.enter)="useEnterKey && invoiceForm.get('txtInvoiceDate').valid ? invoiceNoRef.focus() : invoiceForm.get('txtInvoiceDate').markAsTouched()" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtInvoiceDate')?.touched) && invoiceForm.get('txtInvoiceDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtInvoiceDate').errors.required">Invoice Date is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="InvoiceNo" class="form-label">Invoice No. </label>
                                    <input #invoiceNoRef type="number" formControlName="txtInvoiceNo"
                                        class="form-control form-control-sm" id="InvoiceNo"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtInvoiceNo')?.touched) && invoiceForm.get('txtInvoiceNo').errors}" 
                                        (keydown.enter)="useEnterKey && invoiceForm.get('txtInvoiceNo').valid ? fromDateRef.nativeElement.focus() : invoiceForm.get('txtInvoiceNo').markAsTouched()" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtInvoiceNo')?.touched) && invoiceForm.get('txtInvoiceNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtInvoiceNo').errors.pattern">Maximum upto 15
                                            digits allowed.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <ngb-accordion #a="ngbAccordion" class="accordion range-accordion" [activeIds]="['1']">

                        <ngb-panel id="1">
                            <ng-template ngbPanelTitle class="text-black">
                                <i class="bx bx-search text-primary me-1"></i> Search and filter your invoices
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="fromDate" class="form-label">From Date<span
                                                        class="mandatory">*</span></label>
                                                <input #fromDateRef id="fromDate" class="form-control form-control-sm" type="date"
                                                    placeholder="Select" formControlName="txtFromDate"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtFromDate')?.touched) && invoiceForm.get('txtFromDate').errors}" 
                                                    (keydown.enter)="useEnterKey && invoiceForm.get('txtFromDate').valid ? toDateRef.focus() : invoiceForm.get('txtFromDate').markAsTouched()" >
                                                <div *ngIf="(isFormSubmitted || invoiceForm.get('txtFromDate')?.touched) && invoiceForm.get('txtFromDate').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="invoiceForm.get('txtFromDate').errors.required">Invoice
                                                        is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="toDate" class="form-label">To Date<span
                                                        class="mandatory">*</span></label>
                                                <input #toDateRef id="toDate" class="form-control form-control-sm" type="date"
                                                    placeholder="Select" formControlName="txtToDate"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtToDate')?.touched) && invoiceForm.get('txtToDate').errors}" 
                                                    (keydown.enter)="useEnterKey && invoiceForm.get('txtToDate').valid ? productTypeRef.focus() : invoiceForm.get('txtToDate').markAsTouched()" >
                                                <div *ngIf="(isFormSubmitted || invoiceForm.get('txtToDate')?.touched) && invoiceForm.get('txtToDate').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="invoiceForm.get('txtToDate').errors.required">Invoice is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="productType" class="form-label">Product Type</label>
                                                <ng-select #productTypeRef id="productType" [items]="productTypeList" placeholder="Select"
                                                    bindLabel="name" [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlProductType" 
                                                    (keydown.enter)="useEnterKey && customerRef.focus()"></ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="customer" class="form-label">Customer</label>
                                                <ng-select #customerRef id="customer" [items]="customerList" bindLabel="name"
                                                    placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlCustomer" 
                                                    (keydown.enter)="useEnterKey && statusRef.focus()">
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="mb-2">
                                                <label class="form-label">Status</label>
                                                <ng-select #statusRef [items]="statusList" placeholder="Select" bindLabel="name"
                                                    [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlStatus" multiple="true"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom" 
                                                    (keydown.enter)="useEnterKey && utilities.closeCurrentAndFocusNext(statusRef, shipperRef)">
                                                </ng-select>
                                            </div>
                                        </div>


                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="Shipper" class="form-label">Shipper</label>
                                                <input #shipperRef type="text" class="form-control form-control-sm" id="Shipper"
                                                    placeholder="Search or Enter Name" [resultTemplate]="rt"
                                                    [inputFormatter]="formatter" formControlName="txtShipper"
                                                    [ngbTypeahead]="search"  
                                                    (keydown.enter)="useEnterKey && productRef.focus()"/>

                                                <ng-template #rt let-r="result" let-t="term">
                                                    <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                                    <span> | {{ r['code'] }}</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="vendor">Product</label>
                                                <ng-select #productRef id="product" [items]="productList"
                                                    formControlName="ddlProduct" bindLabel="name" [bindValue]="'id'"
                                                    placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                                    (keydown.enter)="useEnterKey && vendorRef.focus()">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="vendor">Vendor</label>
                                                <ng-select #vendorRef id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                                    bindLabel="name" [bindValue]="'id'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false" (change)="bindService()" 
                                                    (keydown.enter)="useEnterKey && serviceRef.focus()">
                                                </ng-select>

                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="service">Service</label>
                                                <ng-select #serviceRef id="service" [items]="serviceList"
                                                    formControlName="ddlVendorService" bindLabel="servicename"
                                                    [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                                    (keydown.enter)="useEnterKey && billingTypeRef.focus()">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="billingType" class="form-label">Billing Type</label>
                                                <ng-select #billingTypeRef id="billingType" [items]="billingTypeList" placeholder="Select"
                                                    bindLabel="name" [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlBillingType" 
                                                    (keydown.enter)="useEnterKey && originCountryRef.focus()"></ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="businessType" class="form-label">Register Type</label>
                                                <ng-select id="businessType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                                    [items]="registerTypeList" formControlName="ddlRegisterType">
                                                </ng-select>                                                
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-6">
                                            <div class="card">
                                                <div class="card-header bg-transparent border-bottom text-uppercase">
                                                    Origin</div>
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="country" class="form-label">Country</label>
                                                                <ng-select #originCountryRef id="country"
                                                                    formControlName="ddlOriginCountry"
                                                                    placeholder="Select" [items]="countryList"
                                                                    bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false"
                                                                    (change)="onCountryChange('origin')" 
                                                                    (keydown.enter)="useEnterKey && originStateRef.focus()">
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="state" class="form-label">State</label>
                                                                <ng-select #originStateRef id="state" formControlName="ddlOriginState"
                                                                    placeholder="Select" [items]="originStateList"
                                                                    bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false"
                                                                    (change)="onStateChange('origin')" 
                                                                    (keydown.enter)="useEnterKey && originCityRef.focus()" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="city" class="form-label">City</label>
                                                                <ng-select #originCityRef id="city" formControlName="ddlOriginCity"
                                                                    placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                                    [items]="originCityList" bindLabel="name"
                                                                    [bindValue]="'isocode'" 
                                                                    (keydown.enter)="useEnterKey && destinationCountryRef.focus()" />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="card">
                                                <div class="card-header bg-transparent border-bottom text-uppercase">
                                                    Destination</div>
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="country" class="form-label">Country</label>
                                                                <ng-select #destinationCountryRef id="country"
                                                                    formControlName="ddlDestinationCountry"
                                                                    placeholder="Select" [items]="countryList"
                                                                    bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false"
                                                                    (change)="onCountryChange('destination')" 
                                                                    (keydown.enter)="useEnterKey && destinationStateRef.focus()">
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="state" class="form-label">State</label>
                                                                <ng-select #destinationStateRef id="state"
                                                                    formControlName="ddlDestinationState"
                                                                    placeholder="Select" [items]="destinationStateList"
                                                                    bindLabel="name" [bindValue]="'isocode'"
                                                                    [appendTo]="'body'" [openOnEnter]="false" (change)="onStateChange()"  
                                                                    (keydown.enter)="useEnterKey && destinationCityRef.focus()"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="mb-2">
                                                                <label for="city" class="form-label">City</label>
                                                                <ng-select #destinationCityRef id="city"
                                                                    formControlName="ddlDestinationCity"
                                                                    placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                                    [items]="destinationCityList" bindLabel="name"
                                                                    [bindValue]="'isocode'"  
                                                                    (keydown.enter)="useEnterKey && showPODRef.focus()"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-4">
                                            <div class="filter-group mb-2">
                                                <div class="filter-chip">
                                                    <input #showPODRef id="podCollectedEntry" class="form-check-input me-2 pointer custom-check-width"
                                                        type="checkbox" formControlName="txtPodCollectedEntry"
                                                        (keydown.enter)="useEnterKey && serchBtn.focus()"/>
                                                    <label for="podCollectedEntry" class="form-label pointer top-0">Show POD collected entries</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button #serchBtn type="button" class="btn btn-primary btn-sm w-sm" (click)="searchFiltered()">Search</button>
                                </div>
                            </ng-template>
                        </ngb-panel>

                    </ngb-accordion>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="filter-group">
                                <div class="filter-chip action-group"
                                    [ngClass]="{'enabled-background': invoiceForm.get('txtEnabledAWB').enabled}">
                                    <input #companyRef id="received" class="form-check-input me-2 pointer custom-check-width"
                                        type="checkbox" formControlName="txtEnabledAWB" (change)="showDataAWBWise()" />
                                    <label for="received" class="form-label pointer top-0">AWB wise</label>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="this.invoiceForm.get('txtEnabledAWB').value===false">
                            <div class="col-md-12">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                    class="ag-theme-balham" [rowData]="rowDataCustWise"
                                    (rowSelected)="onCustomerSelected()" [columnDefs]="columnDefsCustWise"
                                    [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                    [suppressMenuHide]="true" [pagination]="true"
                                    (gridReady)="onGridReadyCustomerWise($event)" [gridOptions]="gridOptions">
                                </ag-grid-angular>
                            </div>
                        </div>
                        <div class="row" *ngIf="this.invoiceForm.get('txtEnabledAWB').value===true">
                            <div class="col-md-12">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                    class="ag-theme-balham" [rowData]="rowDataAWBWise" [columnDefs]="columnDefsAWBWise"
                                    [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                    [suppressMenuHide]="true" [pagination]="true" (rowSelected)="onAWBSelected()"
                                    (gridReady)="onGridReadyAWBWise($event)" [gridOptions]="gridOptions"
                                    [enableCellTextSelection]="true">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="button-items">
                    <button type="button" class="btn btn-primary w-sm" (click)="generateInvoice()" (keydown.enter)="generateInvoice()">Generate</button>
                    <a routerLink="/invoices/sales">
                        <button type="button" class="btn btn-secondary w-sm">Cancel</button>
                    </a>
                </div>
            </div>
        </div>
    </form>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>